import { useQuery } from '@eika-infrastruktur/react-query';

import { getFundingCertificates } from '../services/fundingCertificatesService';

export const useFundingCertificates = () => useQuery('fundingCertificate', () => getFundingCertificates());
